
    import './styles.scoped.css';
    export default {
  "tutorial-panel": "awsui_tutorial-panel_1oin5_1t5qb_9"
};
  